// frontend/src/pages/ForgotPassword.jsx
import React, { useState } from 'react';
import {
  Paper, TextField, Button, Typography, Box, Alert, CircularProgress,
  InputAdornment, Link as MuiLink
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Email as EmailIcon } from '@mui/icons-material';
import authAPI from '../api/authAPI';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await authAPI.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err?.error || 'Something went wrong — please try again');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc', p: 3 }}>
      <Paper elevation={0} sx={{ width: '100%', maxWidth: 440, p: { xs: 3, sm: 5 }, borderRadius: 3, boxShadow: '0 12px 40px rgba(15, 23, 42, 0.08)' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2.5 }}>
          <Box component="img" src="/images/brand/narevek-crm-logo-mark.png" alt="Narevek CRM" sx={{ width: 180 }} />
        </Box>
        <Typography variant="h4" sx={{ fontWeight: 800, color: '#0f172a', textAlign: 'center' }}>Forgot password?</Typography>
        <Typography variant="body2" sx={{ color: '#64748b', mt: 0.5, mb: 4, textAlign: 'center' }}>
          Enter your account email and we'll send you a link to reset it.
        </Typography>

        {sent ? (
          <Alert severity="success">
            If an account exists for that email, a password reset link has been sent. Check your inbox.
          </Alert>
        ) : (
          <Box component="form" onSubmit={handleSubmit} noValidate>
            <TextField
              margin="normal" required fullWidth autoFocus
              label="Email Address" type="email"
              value={email} onChange={(e) => setEmail(e.target.value)} disabled={loading}
              InputProps={{
                startAdornment: <InputAdornment position="start"><EmailIcon fontSize="small" color="action" /></InputAdornment>
              }}
            />
            {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
            <Button
              type="submit" fullWidth variant="contained" size="large" disabled={loading}
              sx={{
                mt: 3, mb: 2, py: 1.4, fontWeight: 700, fontSize: 16, textTransform: 'none',
                background: 'linear-gradient(135deg, #1e3a8a 0%, #1d4ed8 100%)',
              }}
            >
              {loading ? <CircularProgress size={22} sx={{ color: '#fff' }} /> : 'Send Reset Link'}
            </Button>
          </Box>
        )}

        <Typography variant="body2" sx={{ textAlign: 'center', mt: 2 }}>
          <MuiLink component={RouterLink} to="/login">Back to Sign In</MuiLink>
        </Typography>
      </Paper>
    </Box>
  );
}
